import { onMounted, onUnmounted, ref } from 'vue'
import { initializeNativeIOSLayout } from '@/utils/nativeIOSLayout.js'

export const mobileAccountKey = Symbol('mobile-account')

export function useMobileLayout() {
    const nativeIOS = initializeNativeIOSLayout()
    const media = window.matchMedia('(max-width: 768px)')
    const isMobile = ref(nativeIOS && media.matches)
    const update = () => { isMobile.value = nativeIOS && media.matches }
    onMounted(() => media.addEventListener('change', update))
    onUnmounted(() => media.removeEventListener('change', update))
    return { isMobile }
}
